export class RoleBasedDiscount {
    discountsPerModuleId: number;
    discountModuleId: number;
    allowedPercentage: number;
    createdBy: number;
    roleId: number;
}